import React from 'react';
import PropTypes from 'prop-types';

import {
    Flex,
    token,
} from '@zillow/constellation';

import {
    StyledDesktopText,
    StyledStepContainer,
    StyledCustomStep,
    StyledActiveStep,
    StyledIconCheckmark,
} from './StyledComponents';

const propTypes = {
    index: PropTypes.number, // Passed by ProgressStepper
    activeIndex: PropTypes.number, // Passed by ProgressStepper
    isCompleted: PropTypes.bool, // Passed by ProgressStepper, false by default
    isActive: PropTypes.bool, // Passed by ProgressStepper, false by default
    label: PropTypes.string,
};

const defaultProps = {
    index: -1,
    activeIndex: -1,
    isCompleted: false,
    isActive: false,
    label: '',
};

const Step = ({
    isCompleted,
    isActive,
    activeIndex,
    index,
    label,
}) => {
    const renderDot = () => {
        if (isActive) {
            return <StyledActiveStep />;
        }

        const borderColor = index > activeIndex ? token('colors.gray300') : token('colors.brand');
        if (isCompleted) {
            return (
                <StyledCustomStep backgroundColor={borderColor} borderColor={borderColor}>
                    <StyledIconCheckmark />
                </StyledCustomStep>
            );
        }
        return (
            <StyledCustomStep backgroundColor={token('colors.white')} borderColor={borderColor} />
        );
    };

    return (
        <Flex display="flex" flexDirection="column" alignItems="center">
            <StyledStepContainer isActive={activeIndex === index}>
                {renderDot()}
            </StyledStepContainer>
            {label && (
                <StyledDesktopText fontType="fineprint" isBold={activeIndex === index}>
                    {label}
                </StyledDesktopText>
            )}
        </Flex>
    );
};

Step.propTypes = propTypes;
Step.defaultProps = defaultProps;

export { Step };
export default Step;
